import { useCallback, useEffect, useRef, useState } from 'react';

interface Props {
  className?: string;
  urls: string[];
  title?: string;
  alt?: string;
}

const ProgressiveImage = ({ className, urls, title, alt }: Props): JSX.Element => {
  const imageRef = useRef<HTMLImageElement>(null);
  const [srcIndex, setSrcIndex] = useState(0);

  useEffect(() => {
    setSrcIndex(0);
  }, [urls]);

  const changeToHigherResolution = useCallback(async () => {
    if (srcIndex === urls.length - 1) return;
    if (urls[srcIndex] !== urls[srcIndex + 1]) {
      const image = new Image();
      await new Promise((resolve) => {
        image.onload = resolve;
        image.src = urls[srcIndex + 1];
      });
    }
    setSrcIndex((prev) => Math.min(prev + 1, urls.length - 1));
  }, [srcIndex, urls]);

  useEffect(() => {
    if (imageRef.current?.complete) changeToHigherResolution();
  }, [changeToHigherResolution]);

  return (
    <img
      ref={imageRef}
      className={className}
      alt={alt}
      src={urls[srcIndex]}
      title={title}
      onLoad={changeToHigherResolution}
      onError={changeToHigherResolution}
    />
  );
};

export default ProgressiveImage;
